module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mantra":"Subscribe to Homer newsletter for <br> weekly updates.","subscribe":"Subscribe!"},"ar":{"mantra":"اشترك في النشرة الإخبارية لهومر لتصلك <br>  التحديثات الاسبوعية.","subscribe":"اشترك!"}}')
  delete Component.options._Ctor
}
